export default {
  Usuario: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "usuario"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Usuario.js
// module id = NzI0
// module chunks = 16